import React from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'

const EmailConfirmationModal = ({ isOpen, toggle }) => {
  // Generate unique IDs for accessibility
  const modalId = 'email-confirmation-modal'
  const modalTitleId = 'email-confirmation-title'

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      id={modalId}
      aria-labelledby={modalTitleId}
      role="dialog"
    >
      <ModalHeader toggle={toggle}>
        <span className="sr-only">
          <FormattedMessage id="global.label.close" defaultMessage="Close confirmation message" />
        </span>
      </ModalHeader>
      <ModalBody>
        <h2 id={modalTitleId} className="text-center">
          <FormattedMessage id="page.myRewardsPage.button.emailReward" />
        </h2>
        <p>
          <FormattedMessage id="global.label.messageSent" />
        </p>
      </ModalBody>
      <ModalFooter>
        <div className="w-100">
          <div className="row">
            <div className="col">
              <Button
                block
                outline
                color="light"
                onClick={toggle}
                aria-label="Close confirmation message"
              >
                <FormattedMessage id="global.label.popoverClose" />
              </Button>
            </div>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  )
}

EmailConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
}

export default EmailConfirmationModal
